import React, { useState } from 'react'
import { Stack, Text, Button } from '@chakra-ui/react'
import { Slider } from '@/components/ui/slider'

// This slider implementation abstracts the fact the Chakra slider
// relies on arrays of values, and always receives/returns a single integer.
// We use a localValue to simply allow the current selected number to display
// even it the user is still dragging.
export default function SimpleSlider ({ value, onChange, onChangeEnd, minValue, maxValue }) {
  const [localValue, setLocalValue] = useState(value)
  const defaultValue = ((maxValue ?? 10) + (minValue ?? 1)) / 2
  const hasValue = value !== null && value !== undefined
  return (
    <Stack direction='row' alignItems='end' opacity={hasValue ? 1 : 0.5}>
      <Text color='fg.subtle'>{minValue}</Text>
      <Stack gap={2} flex={1}>
        <Text fontWeight='bold' color='primary.400' textAlign='center'>{hasValue ? localValue : 'No value selected'}</Text>
        <Slider
          flex={1}
          defaultValue={[defaultValue]}
          onValueChange={e => setLocalValue(e.value[0])}
          onValueChangeEnd={e => onChange && onChange(e.value[0])}
          min={minValue}
          max={maxValue}
          value={[localValue ?? value ?? defaultValue]}
        />
      </Stack>
      <Text color='fg.subtle'>{maxValue}</Text>
      <Button
        colorPalette='gray' variant='variant' size='xs' onClick={() => {
          onChange(null)
          setLocalValue(null)
        }}
      >Reset
      </Button>
    </Stack>
  )
}
